import ProgramDetail from "features/LoyaltyPackage/presentation/pages/ProgramDetail";

function ProgramDetailPage() {
  return <ProgramDetail />;
}

export default ProgramDetailPage;
